import { ref, onMounted } from 'vue'

const KEY = '__localStoragePlugin__showNewAdmin'

export function isNewAdminEnabled () {
  if (typeof localStorage === 'undefined') return false

  try {
    const storedValue = localStorage.getItem(KEY)
    return storedValue ? JSON.parse(storedValue) === true : false
  } catch {
    return false
  }
}

/**
 * Composable to read the 'showNewAdmin' feature flag from localStorage once on component mount.
 * @returns A reactive ref for the showNewAdmin flag.
 */
export function useShowNewAdmin () {
  const showNewAdmin = ref(isNewAdminEnabled())

  onMounted(() => {
    showNewAdmin.value = isNewAdminEnabled()
  })

  return {
    showNewAdmin
  }
}
